import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { ChatResponse } from "@/types/chat";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-client";
import { REFETCH_INTERVAL } from "@/lib/constants";

async function getLatestChats(
  uuid: string,
  agent: string,
  token: string,
  threadId?: string
): Promise<ChatResponse> {
  const params = new URLSearchParams({ agent, limit: "2" });
  if (threadId) params.set("threadId", threadId);
  const url = `${config.isometricApiUrl}/chat/byUUID/${uuid}?${params.toString()}`;

  const response = await apiFetch(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error: any = new Error(`HTTP error! status: ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return await response.json();
}

export default function usePollChatService(
  uuid: string,
  agent: string,
  enabled: boolean,
  threadId?: string
) {
  const { getAuthHeaders } = useAuthHeaders();

  return useQuery({
    queryKey: ["poll-chat", uuid, agent, threadId ?? null],
    queryFn: () => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace("Bearer ", "");
      return getLatestChats(uuid, agent, token, threadId);
    },
    enabled,
    refetchInterval: enabled ? REFETCH_INTERVAL : false,
  });
}
